import { render, staticRenderFns } from "./VManageContract.vue?vue&type=template&id=2f290872&"
import script from "./VManageContract.vue?vue&type=script&lang=js&"
export * from "./VManageContract.vue?vue&type=script&lang=js&"
import style0 from "./VManageContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports